import { API_URL } from 'src/config'

const LEXNET_ACTION_PATHS: RegExp[] = [
  /\/mensajes\/[^/]+\/verificacion-lectura$/,
  /\/mensajes\/[^/]+\/descargar$/,
  /\/lexnet\/enviar-bloque$/,
  /\/escrito\/send$/,
  /\/escrito\/enviar-bloque$/,
  /\/acuses\/aceptados-rechazados$/
]

export function isLexnetActionUrl(url: string): boolean {
  if (!url.startsWith(API_URL)) {
    return false
  }
  const path = url.split('?')[0]
  return LEXNET_ACTION_PATHS.some(pattern => pattern.test(path))
}

let handler: (() => void) | null = null

export function setLexnetActivityHandler(fn: (() => void) | null): void {
  handler = fn
}

export function notifyLexnetActivity(): void {
  handler?.()
}
